<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalTableComponentPays from '@/components/pays/ModalTableComponent.vue';
import ModalFormComponentPayroll from '@/components/payroll/ModalFormComponent.vue'
import ModalTableComponentPayroll from '@/components/payroll/ModalTableComponent.vue';
import ModalPayCheckbookFastComponent from '@/components/pays/ModalPayCheckbookFastComponent.vue';
import ModalPayGroupCheckbookFastComponent from '@/components/pays/ModalPayGroupCheckbookFastComponent.vue';
import LoadPay from '@/components/LoadPayPageComponent.vue';

import Catalogue from '@/services/catalogue';

import Pagination from 'vue-pagination-2';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "payroll-paid-table",
	components: {
		ModalTableComponentPays,
		LoadPay,
		Pagination,
		DatePicker,
		ModalFormComponentPayroll,
		ModalTableComponentPayroll,
		ModalPayCheckbookFastComponent,
		ModalPayGroupCheckbookFastComponent
	},
	data() {
		return {
			Arrauthorized: [],
			sendGroup: false,
			checks: [],
			checks_p: [],
			checks_s: [],
			trigger:true,
			init:false,
			search: {
				date: '',
				company_id: '',
				search: '',
				user_id: '',
				type_payment_id: '',
				pay_roll: 1,
				paid: 0,
			},
			order:{
				id:-1,
				name:-1,
				amount:-1,
				amount_payable:-1,
				paid:-1,
				payroll_date:-1,
				authorization_date:0,
				created_at:-1,
			},
			search_all: '',
			page: 1,
			per_page: 10,
			catalogue: new Catalogue(),
			load: false,
		}
	},
	mounted() {
		if(this.authUser.organization_charts_id == 10 || this.authUser.organization_charts_id == 15){ 
            this.catalogue.get_companies_users(this.authUser.id);
        }else{
            this.catalogue.get_company_pays();
        }
		this.catalogue.get_users_employees(2);
        this.catalogue.get_type_payments_payroll();
		this.list();
		this.setHeaderTitle('Pagos Nóminas');
	},
	created() {
		Event.$on("event-load-checks", () => {
			this.list();
		});
	},
	methods: {
		formDataPaysFastGroupCheck() {
			Event.$emit('event-show-showPayGroupCheckbookFast', this.search, this.pays.data);
		},
		showPayroll(payroll) {
			Event.$emit('event-show-addPayroll', payroll);
		},
		sumdata() {
			let sum1 = 0;
			let sum2 = 0;
			let sum3 = 0;
			if (this.checks_s.length>0) {
				this.checks_s.forEach(function (check) {
					if (check.amount) {
						sum1 += parseFloat(check.amount);
					}
					if (check.credit) {
						sum1 += parseFloat(check.credit);
					}
					sum2 += parseFloat(check.amount_payable);
					sum3 += parseFloat(check.sum_pays);

				});
			}

			return [sum1, sum2, sum3];
		},
		selectAll() {
			this.Arrauthorized = [];
			let selected = this.Arrauthorized;
			this.pays.data.forEach(element => {
				if (!selected.includes(element.id)) {
					selected.push(element.id);
				}
			});
			this.Arrauthorized = selected;
		},
		paymentConditions() {
			return this.search.company_id != '' &&
				(this.search.date == '' || this.search.date[0]==null) &&
				this.search.search == '' &&
				this.search.user_id == '' &&
				this.search.type_payment_id == ''
		},
		paymentConditionsCheck() {
			return this.search.company_id != '' &&
				this.search.type_payment_id == 6 &&
				this.search.user_id == '' &&
				(this.search.date == '' || this.search.date[0]==null) &&
				this.search.search == ''
		},
		formListPays(check) {
			Event.$emit('event-show-listPays', check);
		},
		formListFiles(payroll) {
			Event.$emit('event-show-listFiles', payroll);
		},
		async formDataPaysFastCheckbook(check) {
			Event.$emit('event-show-addPayCheckbookFast', check);
		},
		async formDataNomina(check) {
			let company_id = check.pay_roll.company_id;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						check_id: check.id,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
					};
					let _endpoint = '/pay_payroll';
					try {
						let { data } = await request.postMedia(_endpoint, form)
						if (data) {
							console.log(data);
							this.successNotification(data.message);
							this.list();
							Event.$emit('event-load-checks-payroll');
							this.sendGroup = false;

						}
						this.$modal.hide('LoadPay');
					} catch (error) {
						this.$modal.hide('LoadPay');
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
				}
			} else {
				this.$swal({
					title: 'Pago rápido',
					html: 'Se aprobará el pago rápido<br><br><input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							check_id: check.id,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
						};
						let _endpoint = '/pay_payroll';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								this.successNotification(data.message);
								this.list();
								Event.$emit('event-load-checks-payroll');
								this.sendGroup = false;
							}
							this.$modal.hide('LoadPay');
						} catch (error) {
							this.$modal.hide('LoadPay');
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
					}
				});
			}

		},
		async formDataPaysFastGroup() {
			let company_id = this.search.company_id;
			let Arrauthorized = this.Arrauthorized;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						console.log(value);
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						checks_id: Arrauthorized,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
						description: 'Pago aprobado'
					};
					let _endpoint = '/pays_group';
					try {
						let { data } = await request.postMedia(_endpoint, form)
						if (data) {
							console.log(data);
							this.successNotification(data.message);
							this.list();
							Event.$emit('event-load-checks-payroll');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {

				console.log(bancks[0].id);

				this.$swal({
					title: 'Pago rápido',
					text: 'Se aprobara el pago rápido',
					html: '<input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							checks_id: Arrauthorized,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
							description: 'Pago aprobado'
						};
						let _endpoint = '/pays_group';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								console.log(data);
								this.successNotification(data.message);
								this.list();
								Event.$emit('event-load-checks-payroll');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}
		},
		deleted: function (id) {
			let tit = 'Eliminar cheque';
			let txt = 'Seguro que quiere eliminar la cheque';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/checks/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response; });
				this.list();
				Event.$emit('event-load-checks-payroll');
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		async changePage(page = 1){
			this.checks_s=this.checks_p[page-1];
		},
		async sortPage(name){
			switch(name){
				case 'id':
					this.order.id++;
					if(this.order.id%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return a.id - b.id
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return b.id - a.id
						});
					this.order.name=-1;
					this.order.amount=-1;
					this.order.amount_payable=-1;
					this.order.paid=-1;
					this.order.payroll_date=-1;
					this.order.authorization_date=-1;
					this.order.created_at=-1;
				break;
				case 'name':
					this.order.name++;
					if(this.order.name%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return a.pay_roll.company.name.localeCompare(b.pay_roll.company.name)
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return b.pay_roll.company.name.localeCompare(a.pay_roll.company.name)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.amount_payable=-1;
					this.order.paid=-1;
					this.order.payroll_date=-1;
					this.order.authorization_date=-1;
					this.order.created_at=-1;
				break;
				case 'amount':
					this.order.amount++;
					if(this.order.amount%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return a.amount- b.amount
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return b.amount- a.amount
						});
					this.order.id=-1;
					this.order.name=-1;
					this.order.amount_payable=-1;
					this.order.paid=-1;
					this.order.payroll_date=-1;
					this.order.authorization_date=-1;
					this.order.created_at=-1;
				break;
				case 'amount_payable':
					this.order.amount_payable++;
					if(this.order.amount_payable%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return a.amount_payable- b.amount_payable
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return b.amount_payable- a.amount_payable
						});
					this.order.id=-1;
					this.order.name=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.payroll_date=-1;
					this.order.authorization_date=-1;
					this.order.created_at=-1;
				break;
				case 'paid':
					this.order.paid++;
					if(this.order.paid%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return (a.sum_pays??0)- (b.sum_pays??0)
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return (b.sum_pays??0)- (a.sum_pays??0)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.amount_payable=-1;
					this.order.payroll_date=-1;
					this.order.authorization_date=-1;
					this.order.created_at=-1;
				break;
				case 'payroll_date':
					this.order.payroll_date++;
					if(this.order.payroll_date%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return new Date(a.pay_roll.date_start) - new Date(b.pay_roll.date_start)
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return new Date(b.pay_roll.date_start) - new Date(a.pay_roll.date_start)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.amount_payable=-1;
					this.order.paid=-1;
					this.order.authorization_date=-1;
					this.order.created_at=-1;
				break;
				case 'authorization_date':
					this.order.authorization_date++;
					if(this.order.authorization_date%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return new Date(a.authorization_date) - new Date(b.authorization_date)
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return new Date(b.authorization_date) - new Date(a.authorization_date)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.amount_payable=-1;
					this.order.paid=-1;
					this.order.payroll_date=-1;
					this.order.created_at=-1;
				break;
				case 'created_at':
					this.order.created_at++;
					if(this.order.created_at%2==0)
						this.checks=this.checks.sort((a,b)=>{
							return new Date(a.created_at) - new Date(b.created_at)
						});
					else
						this.checks=this.checks.sort((a,b)=>{
							return new Date(b.created_at) - new Date(a.created_at)
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.amount_payable=-1;
					this.order.paid=-1;
					this.order.payroll_date=-1;
					this.order.authorization_date=-1;
				break;
			}
		},
		async list() {
			this.order={
				id:-1,
				name:-1,
				amount:-1,
				amount_payable:-1,
				paid:-1,
				payroll_date:-1,
				authorization_date:0,
				created_at:-1,
			};
			this.init=false;
			this.checks = [];
			this.page=1;
			this.load = true;
			let service = request;
			let search = this.search;
			search.search = this.search_all;
			let _endpoint = '/pays';
			try {
				let { data } = await service.list(_endpoint, this.page, search)
				if (data) {
					this.init=this.search.company_id == '' &&
						this.search.search == '' &&
						(this.search.date == '' || this.search.date[0]==null) &&
						this.search.user_id == ''  &&
						this.search.type_payment_id == '';
					this.checks = data.data;
					this.sortPage('authorization_date');
					if(data.dates[0]!=''){
						this.trigger=false;
						this.search.date = data.dates;
					}
					this.Arrauthorized = [];
				}
			} catch (error) {
				console.log(error);
			} finally{
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
	watch: {
		'checks': {
			handler: function () {
				if(this.checks.length>0){
					let vm=this,k=0,j=1;
					this.checks_p=[];
					this.checks_p[0]=[];
					this.checks.forEach(s=>{
						vm.checks_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.checks_p[k]=[];
						}
						j++;

					});
					this.checks_s=this.checks_p[this.page-1];
				}else{
					this.checks_p=[];
					this.checks_s=[];
				}
			},
			deep: true
		},
		'per_page': {
			handler: function () {
				this.page=1;
				if(this.checks.length>0){
					let vm=this,k=0,j=1;
					this.checks_p=[];
					this.checks_p[0]=[];
					this.checks.forEach(s=>{
						vm.checks_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.checks_p[k]=[];
						}
						j++;

					});
					this.checks_s=this.checks_p[this.page-1];
				}
			},
			deep: true
		},
		'search_all': {
			handler: function (val) {
				if (val == '') {
					this.list();
				}
			},
			deep: true
		},
		"search": {
			handler: function () {
				this.page = 1;
				if(this.trigger)
					this.list();
				else
					this.trigger=true;
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.checks-page {
	padding-bottom: 20px;
}

.card-header {
	padding: 16px 20px;
}

.card-title {
	font-size: 18px;
	font-weight: 600;
}

.checks-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	align-items: center;
	justify-content: flex-end;
}

.checks-actions .btn {
	white-space: nowrap;
}

/* Filtros */

.filters-panel {
	padding: 18px 18px 3px;
	margin-bottom: 20px;
	background-color: #f8f9fa;
	border: 1px solid #e3e6e9;
	border-radius: 8px;
}

.filters-heading h6 {
	font-size: 16px;
	color: #2f343a;
}

.filters-panel label {
	margin-bottom: 6px;
	font-size: 13px;
	font-weight: 600;
	color: #495057;
}

.filters-grid {
	margin-right: -8px;
	margin-left: -8px;
}

.filters-grid > [class*="col-"] {
	margin-top: 0 !important;
	margin-bottom: 15px;
	padding-right: 8px;
	padding-left: 8px;
}

.filters-panel .form-control,
.filters-panel >>> .mx-input {
	height: 40px;
	font-size: 14px;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background-color: #ffffff;
	box-shadow: none;
}

.filters-panel .form-control:focus,
.filters-panel >>> .mx-input:focus {
	border-color: #80bdff;
	box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.08);
}

.search-input-wrapper {
	position: relative;
}

.search-input-wrapper > i {
	position: absolute;
	top: 50%;
	left: 13px;
	z-index: 2;
	color: #6c757d;
	font-size: 13px;
	transform: translateY(-50%);
	pointer-events: none;
}

.search-input-wrapper .form-control {
	padding-left: 36px;
}

.date-filter,
.date-filter >>> .mx-datepicker {
	width: 100%;
}

.default-period-badge {
	display: inline-flex;
	align-items: center;
	padding: 5px 9px;
	color: #856404;
	background-color: #fff3cd;
	border: 1px solid #ffe69c;
	border-radius: 14px;
	font-size: 11px;
	font-weight: 600;
	white-space: nowrap;
}

.complement-filter {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 40px;
	margin-top: 25px !important;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background-color: #ffffff;
	color: #495057;
	font-size: 13px;
	font-weight: 600;
}

.complement-filter:hover {
	color: #0056b3;
	background-color: #f3f7fc;
	border-color: #80bdff;
}

.complement-filter.active {
	color: #0056b3;
	background-color: #e7f1ff;
	border-color: #4b72d9;
}

/* Tarjetas de resumen */

.checks-summary {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 17px;
	margin-bottom: 20px;
}

.summary-card {
	display: flex;
	align-items: center;
	min-height: 85px;
	padding: 15px;
	background-color: #ffffff;
	border: 1px solid #e5e7eb;
	border-left: 4px solid #6c757d;
	border-radius: 8px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);
}

.summary-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 44px;
	width: 44px;
	height: 44px;
	margin-right: 13px;
	font-size: 18px;
	color: #2f343a;
	background-color: #f1f3f5;
	border-radius: 50%;
}

.summary-card span {
	display: block;
	margin-bottom: 1px;
	font-size: 12px;
	color: #6c757d;
	text-transform: uppercase;
	letter-spacing: 0.3px;
}

.summary-card strong {
	display: block;
	font-size: 22px;
	line-height: 1.1;
	color: #212529;
	word-break: break-word;
}

.summary-total {
	border-left-color: #6c757d;
}

.summary-amount {
	border-left-color: #28a745;
}

.summary-pending {
	border-left-color: #ffc107;
}

.summary-paid {
	border-left-color: #4b72d9;
}

/* Tabla */

.table-container {
	overflow: hidden;
	border: 1px solid #dee2e6;
	border-radius: 8px;
}

.checks-table-wrapper {
	position: relative;
	/* height: clamp(420px, calc(100vh - 560px), 760px); */
	max-height: 420px;
	overflow-x: auto !important;
	overflow-y: auto !important;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
}

.checks-table {
	width: 100%;
	min-width: 1320px;
	margin-bottom: 0;
	table-layout: fixed;
	border-collapse: separate;
	border-spacing: 0;
}

.checks-table thead th {
	position: sticky;
	top: 0;
	z-index: 20;
	padding: 12px 8px;
	vertical-align: middle;
	font-size: 12px;
	font-weight: 700;
	color: #343a40;
	background-color: #f1f3f5;
	border-bottom: 2px solid #d9dde1;
	text-transform: uppercase;
	box-shadow: 0 2px 0 #d9dde1;
}

.checks-table tbody td {
	padding: 11px 8px;
	vertical-align: middle;
	font-size: 12px;
	line-height: 1.45;
	background-color: #ffffff;
}

.checks-table tbody tr {
	transition: background-color 0.15s ease;
}

.checks-table tbody tr:hover td {
	background-color: #f8fafc !important;
}

.check-row td:first-child {
	border-left: 4px solid #6c757d;
}

.check-row td:first-child {
	border-left: 4px solid #6c757d;
}

.partner-row td:first-child {
	border-left: 4px solid #6c757d;
}

.data-column {
	width: 390px;
}

.amount-column {
	width: 140px;
}

.date-column {
	width: 160px;
}

.actions-column {
	width: 310px;
}

.check-column {
	width: 70px;
}

.payment-id-cell {
	font-size: 14px !important;
	font-weight: 700;
}

.payment-id {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 40px;
	min-height: 30px;
	padding: 4px 8px;
	color: #343a40;
	background-color: #f1f3f5;
	border-radius: 6px;
}

.data-cell {
	color: #495057;
}

.data-cell > span {
	display: block;
}

.data-cell strong {
	color: #2f343a;
	font-weight: 600;
}

.data-cell hr {
	margin: 9px 0;
	border-top-color: #e3e6e9;
}

.amount-cell,
.pending-cell,
.paid-cell {
	font-size: 13px !important;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}

.amount-payable-cell,
.pending-cell {
	color: #856404;
}

.amount-paid-cell,
.paid-cell {
	color: #1d7a36;
}

.date-cell {
	font-size: 12px !important;
	color: #6c757d;
}

.actions-cell {
	padding: 9px !important;
}

.actions-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	align-items: center;
	justify-content: center;
}

.actions-wrap .d-inline {
	display: contents !important;
}

.actions-wrap hr {
	flex: 0 0 100%;
	width: 100%;
	margin: 3px 0;
	border-top-color: #e1e5e9;
}

.actions-wrap .btn,
.actions-wrap a.btn {
	margin: 0 !important;
	padding: 5px 8px;
	border-radius: 6px;
	/* background-color: #ffffff; */
	font-size: 11px;
	font-weight: 500;
	line-height: 1.3;
	white-space: normal;
	box-shadow: none;
}

/* .actions-wrap .btn-outline-light {
	color: #6c757d;
	border-color: #6c757d;
}

.actions-wrap .btn-outline-light:hover {
	color: #ffffff;
	background-color: #6c757d;
} */

.table-state {
	height: 250px;
	padding: 0 !important;
}

.loading-state,
.empty-state {
	padding: 50px 20px;
	text-align: center;
}

.loading-state i,
.empty-state i {
	margin-bottom: 12px;
	font-size: 36px;
	color: #adb5bd;
}

.loading-state h5,
.empty-state h5 {
	margin-bottom: 4px;
	font-size: 15px;
	font-weight: 600;
	color: #343a40;
}

.loading-state p,
.empty-state p {
	margin-bottom: 0;
	font-size: 12px;
	color: #6c757d;
}

.totals-row td {
	position: sticky;
	bottom: 0;
	z-index: 4;
	padding: 12px 8px;
	font-weight: 700;
	color: #343a40;
	background-color: #e9ecef !important;
	border-top: 2px solid #ced4da;
	font-variant-numeric: tabular-nums;
}

.pagination-wrapper {
	display: flex;
	justify-content: flex-end;
	padding: 13px 16px;
	background-color: #ffffff;
	border-top: 1px solid #dee2e6;
}

.pagination-wrapper >>> .pagination {
	margin-bottom: 0;
}

.selected td {
	background-color: #f1f5ff !important;
}

.selected td:first-child {
	border-left-color: #4b72d9;
}

/* Modal de tipo de pago */

.btn-app {
	margin: 0;
	height: 80px;
}

.f-30 {
	font-size: 30px;
}

.payment-type-modal >>> .v--modal {
	border-radius: 8px;
	overflow: visible;
}

.payment-type-modal .modal-header {
	padding: 18px 20px 8px;
	border-bottom: 0;
}

.payment-type-modal .modal-title {
	margin-bottom: 0;
	font-size: 17px;
	font-weight: 600;
}

.modal-subtitle {
	margin: 4px 0 0;
	font-size: 12px;
	color: #6c757d;
}

.payment-type-modal .modal-body {
	padding: 10px 20px 20px;
}

.payment-type-modal .btn-closed {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 4;
	width: 30px;
	height: 30px;
	padding: 0;
	border-radius: 50%;
}

.payment-option-btn {
	display: flex !important;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 7px;
	height: 90px !important;
	border: 1px solid #dee2e6;
	border-radius: 8px;
	background-color: #f8f9fa;
	color: #343a40;
	font-size: 12px;
	font-weight: 600;
}

.payment-option-btn:hover {
	color: #0056b3;
	background-color: #eef5ff;
	border-color: #80bdff;
}

/* Responsive */

@media (max-width: 1199px) {
	.checks-summary {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.checks-table-wrapper {
		height: 60vh;
		max-height: 420px;
	}
}

@media (max-width: 767px) {
	.card-header {
		padding: 14px;
	}

	.card-body {
		padding: 14px;
	}

	.checks-actions {
		width: 100%;
		justify-content: flex-start;
	}

	.filters-panel {
		padding: 15px 15px 0;
	}

	.checks-summary {
		grid-template-columns: 1fr;
		gap: 10px;
	}

	.summary-card {
		min-height: 75px;
	}

	.pagination-wrapper {
		justify-content: center;
		overflow-x: auto;
	}

	.checks-table-wrapper {
		height: 65vh;
		max-height: 400px;
	}
}

@media (max-width: 575px) {
	.checks-actions {
		display: grid;
		grid-template-columns: 1fr;
	}

	.checks-actions .btn {
		width: 100%;
	}

	.filters-heading {
		align-items: flex-start !important;
		flex-direction: column;
	}

	.default-period-badge {
		white-space: normal;
	}
}
</style>

<template>
	<div class="col-12 checks-page">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<div class="d-flex flex-wrap align-items-center justify-content-between">
					<div>
						<h3 class="card-title">
							<i class="fa-solid fa-money-check-dollar mr-2"></i>
							Lista de Pagos de Nóminas
						</h3>
						<br>
						<small class="text-muted d-block mt-1">
							Consulta, filtra y administra los movimientos registrados.
						</small>
					</div>
				</div>
			</div>
			<div class="card-body">
				<section class="filters-panel">
					<div class="d-flex align-items-center justify-content-between mb-3 filters-heading">
						<h6 class="mb-0 font-weight-bold">
							<i class="fa-solid fa-filter mr-1"></i>
							Filtros
						</h6>

						<span v-if="init" class="default-period-badge">
							<i class="fa-regular fa-calendar mr-1"></i>
							Periodo predeterminado
						</span>
					</div>

					<div class="row filters-grid">
						<div class="col-md-7 col-lg-8">
							<label>Buscar :</label>
							<input class="form-control" v-debounce:2s="list" type="search" v-model="search_all">
						</div>
						<div class="col-md-5 col-lg-4">
							<label>Rango de fechas :</label>
							<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
								v-model="search.date"></date-picker>
							<div v-if="init" class="text-danger">Periodo por Defecto</div>
						</div>
						<div class="col-md-4 mt-2">
							<label>Empresa :</label>
							<select v-model="search.company_id" class="form-control" v-if="authUser.organization_charts_id != 10 && authUser.organization_charts_id != 15">
								<option value=""> Sin empresa </option>
								<option v-for="(company, index) in catalogue.company_pays" :value="company.id" :key="index">
									{{ company.name }}</option>
							</select>

							<select v-model="search.company_id" class="form-control" v-else>
								<option value=""> Sin empresa </option>
								<option v-for="(company, index) in catalogue.companies_users" :value="company.id" :key="index">
									{{ company.name }}
								</option>
							</select>
						</div>
						<div class="col-md-4 mt-2">
							<label>Empleado :</label>
							<select type="text" class="form-control" v-model="search.user_id">
								<option value="">Todos</option>
								<option v-for="(user, index) in catalogue.users_employees" :value="user.id" :key="index">
									{{ user.name }} {{ user.last_name }}</option>
							</select>
						</div>
						<div class="col-md-4 mt-2">
							<label>Tipo de pago</label>
							<select type="text" class="form-control" v-model="search.type_payment_id">
								<option value="">Todos</option>
								<option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
									:value="type_payment.id" :key="index_type_payment">{{
										type_payment.name }}</option>
							</select>
						</div>
					</div>
				</section>
				<section class="table-container results-panel">
					<div class="row">
						<div class="col-md-6">
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" @click="search.paid = 0" data-toggle="pill" role="tab"
										aria-selected="true">Por pagar</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="search.paid = 1" data-toggle="pill" role="tab"
										aria-selected="false">Pagados</a>
								</li>
							</ul>
						</div>
						<div class="col-md-6">
							<!-- <button class="btn btn-outline-success btn-sm mr-2" v-can="'export_payroll'"
								@click="exportData()">
								<i class="fa fa-file-excel"></i> Exportar
							</button> -->
							<label>
								<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
									<li class="nav-item">
										<label class="nav-link">Resultados por P&aacute;gina:</label>
									</li>
									<li class="nav-item">
										<a class="nav-link active" @click="per_page = 10" data-toggle="pill" aria-selected="true">10</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" @click="per_page = 20" data-toggle="pill" aria-selected="false">20</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" @click="per_page = 50" data-toggle="pill" aria-selected="false">50</a>
									</li>
								</ul>
							</label>
						</div>
					</div>
					<div class="table-responsive checks-table-wrapper">
						<table class="table table-bordered text-sm text-center checks-table">
							<thead>
								<tr>
									<th class="check-column">ID
										<button class="btn btn-xs" @click.prevent="sortPage('id')">
											<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="data-column">Datos
										<button class="btn btn-xs" @click.prevent="sortPage('name')">
											<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Monto
										<button class="btn btn-xs" @click.prevent="sortPage('amount')">
											<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Por pagar
										<button class="btn btn-xs" @click.prevent="sortPage('amount_payable')">
											<i class="fa" :class="order.amount_payable==-1?'fa-minus':(order.amount_payable%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Pagado
										<button class="btn btn-xs" @click.prevent="sortPage('paid')">
											<i class="fa" :class="order.paid==-1?'fa-minus':(order.paid%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha de aprobación
										<button class="btn btn-xs" @click.prevent="sortPage('authorization_date')">
											<i class="fa" :class="order.authorization_date==-1?'fa-minus':(order.authorization_date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha de creación
										<button class="btn btn-xs" @click.prevent="sortPage('created_at')">
											<i class="fa" :class="order.created_at==-1?'fa-minus':(order.created_at%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha de nómina
										<button class="btn btn-xs" @click.prevent="sortPage('payroll_date')">
											<i class="fa" :class="order.payroll_date==-1?'fa-minus':(order.payroll_date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="text-center actions-column">Opciones</th>
									<th v-can="'add_pays_fast'" v-if="paymentConditions()" class="text-center check-column">
										<button class="btn btn-sm btn-info" @click="selectAll">
											<i class="fa-solid fa-check-double"></i>
										</button>
									</th>
									<th v-can="'add_pays_fast'" v-if="paymentConditionsCheck()" class="text-center check-column">
										<button class="btn btn-sm btn-info" @click="selectAll">
											<i class="fa-solid fa-check-double"></i>
										</button>
									</th>
								</tr>
							</thead>
							<tbody v-if="load">
								<tr>
									<td align="center" colspan="9">
										<div class="loading-state">
											<i class="fa-solid fa-circle-notch fa-spin"></i>
											<h5>Cargando pagos</h5>
											<p>Estamos consultando la informaci&oacute;n.</p>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="checks_s && checks_s.length > 0">
								<tr class="check-row" :class="check.id == selected ? 'selected' : ''" v-for="(check, index) in checks_s" :key="index">
									<td class="check-cell">{{ check.id }}</td>
									<td class="data-cell">
										<!-- Tipo -->
										<!-- Nomina -->
										<span v-if="check.payroll_id">
											<span v-if="check.type_payment && check.type_payment.name!='Dispersión'">
												<strong>Empleado : </strong>
												<span v-if="check.user&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.pay_roll.company_id }))">{{check.user.name}} {{check.user.last_name}}</span>
												<span v-else-if="check.user">XXXXXXXXXXX</span>
												<span v-else>Sin usuario</span>
												<span v-if="(user=check.pay_roll.users.filter((user, index) => { return (user.id == check.user_id)})[0]) && (bank = check.user.bank_accounts.filter((bank, index) => { return (user.pivot.bank_account_id == bank.id)})[0])">
												<br>
													<strong>Cuenta bancaria: </strong>
													<span v-if="authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.pay_roll.company_id })">{{bank.account_number }}</span>
													<span v-else>XXXXXXXXXXX</span>
												</span>
												<!-- <span v-else>No Aplica</span> -->
												<br>
											</span>
											<strong>Compañía : </strong>
											{{ check.pay_roll.company.name }}<br>
											<strong>Fecha inicio : </strong>
											{{ check.pay_roll.date_start | toDateTime }}<br>
											<strong>Fecha fin : </strong>
											{{ check.pay_roll.date_end | toDateTime }}<br>
											
											<strong>Tipo de Pago : </strong>
											<span v-if="check.type_payment">
												{{ check.type_payment.name }}
											</span>
											<span v-else>Sin tipo</span>
											<br>
											<strong>Monto : </strong>
											{{ check.pay_roll.amount | toCurrency }}<br>
											<span v-for="(pay, index) in check.pay" :key="index">
												{{ pay.date | toDateTime }} - {{ pay.amount | toCurrency }}<br>
											</span>
											<span v-if="check.pay && check.pay.length!=0&&check.type_payment_id==6">
												<strong >Cheques:</strong>
												<span v-for="(pay, index) in check.pay" :key="index">
													{{ pay.checkbook?pay.checkbook.name:'' }} - Folio: {{ pay.folio }}<br>
												</span>
											</span>
											<span v-if="search.paid==0 && check.folio_prev && check.type_payment_id==6">
												<strong >Cheque Guardado:</strong>
													{{ check.checkbook?check.checkbook.name:'' }} - Folio: {{ check.folio_prev }}<br>
											</span>
											<button v-if="check.pay_roll&&check.type_payment && check.type_payment.name=='Dispersión'&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.pay_roll.company_id }))" @click="showPayroll(check.pay_roll)"
												class="btn btn-outline-secondary m-1 btn-sm">
												<i class="fa-solid fa-receipt mr-1"></i> Ver nómina
											</button><br>
											<button v-if="check.pay_roll.files.length>0&&(authUser.organization_charts_id==1 || authUser.companies.some((spec, index) => { return spec.id == check.pay_roll.company_id }))" @click="formListFiles(check.pay_roll)"
												class="btn btn-outline-secondary m-1 btn-sm">
												<i class="fa-solid fa-receipt mr-1"></i> Ver archivos
											</button>
										</span>
									</td>
									<td class="amount-cell">
										{{ (check.amount + check.credit) | toCurrency }}
									</td>
									<td class="amount-cell">
										<strong style="font-weight: 900;">{{ check.amount_payable | toCurrency }}</strong>
									</td>
									<td class="amount-cell">
										{{ check.sum_pays | toCurrency }}
									</td>
									<td class="date-cell">
										<span v-if="check.user_approved"> {{ check.authorization_date | toDateTime }} </span>
										<span v-else>Sin Fecha</span>
									</td>
									<td class="date-cell">
										{{ check.created_at | toDateTime }}
									</td>
									<td class="date-cell">
										<span v-if="check.pay_roll">
											{{ check.pay_roll.date_start | toDateTime }} - {{ check.pay_roll.date_end | toDateTime }}
										</span>
										<span v-else>
											S/F
										</span>

									</td>
									<td class="actions-cell">
										<div class="actions-wrap">
											<div class="d-inline" v-if="check.pay.length == 0">
												<button v-if="check.payroll_id && check.type_payment_id != 6"
													@click="formDataNomina(check)"
													class="btn btn-outline-info m-1 btn-sm">
													<i class="fa-regular fa-handshake mr-1"></i>
													Pago rápido
												</button>

												<button v-if="check.payroll_id && check.type_payment_id == 6"
													@click="formDataPaysFastCheckbook(check)"
													class="btn btn-outline-info m-1 btn-sm">
													<i class="fa-regular fa-handshake mr-1"></i>
													Pago rápido cheque
												</button>
											</div>

											<button type="button" v-if="check.payroll_id" @click="deleted(check.id)"
												v-can="'deleted_checks'" class="btn-outline-danger btn m-1 btn-sm ">
												<i class="fa fa-trash"></i> Eliminar
											</button>
											<button @click="formListPays(check)" class="btn m-1 btn-sm btn-outline-warning">
												<i class="fa-solid fa-hand-holding-dollar mr-1"> </i>
												<span>Ver pago</span>
											</button>
										</div>
									</td>
									<th class="check-cell" v-can="'add_pays_fast'" v-if="paymentConditions()">
										<input type="checkbox" :disabled="check.type_payment_id == 6"
											class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">																		
									</th>
									<th class="check-cell" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
										<input type="checkbox" :disabled="check.type_payment_id != 6"
											class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">
										<br>
										<span v-if="check.checkbook" class="badge badge-info">
										{{ check.checkbook.name }}
										<br>-<br>
										{{ check.folio_prev }}
										</span>
									</th>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td align="center" colspan="9">Sin resultados.</td>
								</tr>
							</tbody>
							<tfoot v-if="checks_s.length > 0 && load == false">
								<tr class="totals-row">
									<td colspan="2">
										Total :
									</td>
									<td class="amount-cell">
										{{ sumdata()[0] | toCurrency }}
									</td>
									<td class="amount-cell">
										{{ sumdata()[1] | toCurrency }}
									</td>
									<td class="amount-cell">
										{{ sumdata()[2] | toCurrency }}
									</td>
									<td colspan="4"></td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="pagination-wrapper" v-if="checks_p.length">
						<pagination v-model="page" :records="parseInt(checks.length)" :per-page="parseInt(per_page)"
							@paginate="changePage" />
					</div>
				</section>
				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditions()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" v-if="!sendGroup" @click="formDataPaysFastGroup()">
							<i class="fa-solid fa-list-check"></i> Pago rápido
							seleccionado
						</button>
						<button class="btn btn-outline-info" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" v-if="!sendGroup" @click="formDataPaysFastGroupCheck()">
							<i class="fa-solid fa-list-check"></i> Pago de cheque agrupado
						</button>
						<button class="btn btn-outline-info" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

			</div>
		</div>

		<ModalTableComponentPays :prop_edit="false" />
		<LoadPay />
		<ModalFormComponentPayroll :prop_edit="false" />
		<ModalTableComponentPayroll/>
		<ModalPayCheckbookFastComponent />
		<ModalPayGroupCheckbookFastComponent />
	</div>
</template>



<style scoped>
.pagination {
	margin-bottom: 0;
}

.bg-info {
	background-color: #061f3f;
}

.pay_load {
	z-index: 5;
	position: absolute;
	width: 98%;
	height: 100%;
	border-radius: 10px;
	background: #204d83cc;
}

.load_pay {

	position: fixed;
	display: block;
	top: 20%;
	transform: translateY(-20%);
	left: 50%;
	transform: translateX(-50%);
}
</style>
